package ui.showcase.showcases

import adapters.Api
import emotion.react.css
import react.*
import react.dom.html.ReactHTML
import react.router.useNavigate
import ru.malygin.myConst.ApiReturns
import ru.malygin.myConst.DtoItemSubInfo
import ru.malygin.myConst.ScheduleChange
import ru.malygin.myConst.SelectedCategory
import ui.new_ui.components.loaders.circle_loaders.CircleLoader
import ui.new_ui.components.search.Search
import ui.router.RouterRoute
import ui.styles.ScheduleChangeStyle
import ui.styles.Styles
import ui.themePlusContext.MyContext
import ui.themePlusContext.ToastContext
import ui.themePlusContext.ToastData
import ui.themePlusContext.ToastTypes
import utils.logger.log
import web.cssom.ClassName
import web.cssom.number
import web.cssom.pct

val ScheduleChangeScreen = FC{
//    document.title = RouterRoute.CHANGE_SCHEDULE.title ?: document.title

    var selectedInfo by useState<String?>(null)
    var selectedCategory by useState<SelectedCategory>(SelectedCategory.NONE)

    var titleTest by useState<String>("")
    val navigate = useNavigate()

    var errorMessage by useState<String?>(null)
    var alertHandler by useState(false)
    var receivedList:List<ScheduleChange>? by useState(null)

    val ctx = useContext(MyContext)
    val toast = useContext(ToastContext)

    fun alertCh(erMsg:String?){
        if (erMsg.isNullOrEmpty()){
            alertHandler = false
            errorMessage = null
        }else{
            alertHandler = true
            errorMessage = erMsg
        }
    }

    useEffectOnce {
        when(val ret = Api().getScheduleChangeList()){
            is ApiReturns.Error -> {
                log.e("return Error")
                alertCh(ret.code.message)
            }
            is ApiReturns.SuccessForScheduleChange -> {
                alertCh(null)
                receivedList = ret.data
            }
            else -> {}
        }
    }


    ReactHTML.div{
        className = ScheduleChangeStyle.scheduleChangeMainBox

        ReactHTML.div{
            className = ScheduleChangeStyle.scheduleTitle

            +"Выберите подходящие расписание"

            Search{
                onUpdate = {
                    titleTest = it
                }
            }
        }

        ReactHTML.section{
            className = ScheduleChangeStyle.scheduleMain

            receivedList?.let { received ->

                received.forEach {schC->
                    listBlock{
                        this.currentSelectedCategory = schC.category
                        this.list = schC.dtoItem.filter {
                            it.name.lowercase().contains(titleTest.lowercase())
                        }
                        this.selectedID = {
                            selectedInfo = it
                            selectedCategory = schC.category
                        }
                        this.selectedName = selectedInfo
                    }
                }

            }?: run {
                CircleLoader{
                    isLoading = errorMessage.isNullOrEmpty()
                }
            }

            errorMessage?.let {
                ReactHTML.span{
                    +"ERROR: $it"
                }
            }
        }

        ReactHTML.div{
            className = ScheduleChangeStyle.selectedInfo

            +if(selectedInfo == null){ "Ничего не выбрано" } else selectedInfo
        }

        ReactHTML.div{
            className = ScheduleChangeStyle.confirmButton

            ReactHTML.button{
                className = Styles.Buttons.button

                onClick = {_->
                    selectedInfo?.let {
                        ctx.setName(
                            it,
                            selectedCategory
                        )

                        navigate(RouterRoute.MAIN_PAGE.route)
                    } ?: run {
                        toast.open(
                            ToastData(
                                message = "Ничего не выбрано",
                                type = ToastTypes.WARNING,
                                timeout = 1000
                            )
                        )
                    }
                }

                +"Подтвердить выбор"
            }
        }

    }
}

private external interface ListBlockProps : Props{
    var currentSelectedCategory: SelectedCategory
    var list: List<DtoItemSubInfo>
    var selectedID: (String) -> Unit
    var selectedName: String?
}

private val listBlock = FC<ListBlockProps> {props->
    ReactHTML.h1{
        className = ScheduleChangeStyle.listHeader

        +props.currentSelectedCategory.trn
    }

    ReactHTML.menu{
        className = ScheduleChangeStyle.listHandler

        props.list.forEach {sci->

            ReactHTML.li{
                className = ScheduleChangeStyle.listItem

                listButton{
                    this.onClick = {
                        props.selectedID(sci.name)
                    }
                    this.subInfo = sci
                    this.selectedName = props.selectedName
                }
            }
        }
    }
}

private external interface ListButtonProps : Props{
    var onClick: () -> Unit
    var subInfo: DtoItemSubInfo
    var selectedName: String?
}

private val listButton = FC<ListButtonProps> {props->
    ReactHTML.button{
        className = Styles.Buttons.buttonInset

        val newClass = if (props.selectedName == props.subInfo.name) ClassName("${this.className} Button_inset_target") else this.className

        className = newClass

        css(this.className) {
            width = 100.pct
        }


        onClick = {
            props.onClick()
        }

        ReactHTML.h2{
            +props.subInfo.name
        }
        ReactHTML.h4{

            css {
                opacity = number(0.6)
            }

            +props.subInfo.subInfo
        }
    }
}